import React, { Dispatch, SetStateAction } from 'react';
import {
  StyleSheet, Text, TouchableOpacity,
} from 'react-native';
import Colors from '../../../../../constants/Colors';
import { alternateLineColor, selectedLineColor } from '../../../../../graphs/AirQualityGraph';

interface MetricSelectionButtonProps {
  title: string,
  unit: string,
  onPress: Dispatch<SetStateAction<number>>,
  index: number,
  selected?: boolean,
  alternateSelected?: boolean,
}

const MetricSelectionButton = ({
  title, unit, onPress, index, selected, alternateSelected,
}: MetricSelectionButtonProps) => <TouchableOpacity
  key={`metricSelectionButton_${index}`}
  onPress={() => onPress(index)}
  style={[
    styles.container, selected && styles.selected, alternateSelected && styles.alternateSelected,
  ]}>
    <Text style={[styles.title, (selected || alternateSelected) && styles.titleSelected]}>
      {title}
    </Text>
    <Text style={[styles.title, (selected || alternateSelected) && styles.titleSelected,
      { fontSize: 10 }]}>{unit}</Text>
  </TouchableOpacity>;

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 4,
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksWhite100,
    paddingVertical: 16,
    paddingHorizontal: 20,
    flex: 1,
  },
  selected: {
    backgroundColor: selectedLineColor,
  },
  alternateSelected: {
    backgroundColor: alternateLineColor,
  },
  title: {
    fontSize: 14,
    lineHeight: 20,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
    textAlign: 'center',
  },
  titleSelected: {
    color: '#FFF',
  },
});

export default MetricSelectionButton;
